<template>
  <div>
    <section
      class="wf100 subheader"
      style="margin-bottom: 10px; background: #048042"
    >
      <div class="container">
        <li>
          <h2>{{ detailsDonation.name_ar }}</h2>
        </li>
        <ul>
          <li v-if="$route.params.details_donation_id">المنظمة</li>
          <li v-else>
            <router-link to="/" href="#">الرئيسية</router-link>
          </li>
          <li>حملات التبرع</li>
        </ul>
      </div>
    </section>

    <div v-if="loadingDetailsDonation">
      <div class="row shadow p-2 bg-white rounded mt-2 mb-3">
        <div class="col-md-6 col-xs-12">
          <b-skeleton height="275px" width="90%" style="margin: 10px">
          </b-skeleton>
        </div>
        <div class="col-md-6 col-xs-12">
          <div class="my-2">
            <b-skeleton animation="fade" width="20%"></b-skeleton>
            <b-skeleton animation="fade" width="85%"></b-skeleton>
            <b-skeleton animation="fade" width="85%"></b-skeleton>
            <b-skeleton animation="fade" width="85%"></b-skeleton>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="container">
      <div>
        <div>
          <!-- <basc-card> -->
          <div class="row shadow p-2 bg-white rounded mt-2 mb-3">
            <div class="col-lg-6 col-md-12">
              <img :src="detailsDonation.image" class="img_donation" />
              <div class="my-3 row">
                <div class="col-md-6 mt-2">
                  <b-media no-body style="display: flex; align-items: center">
                    <b-media-aside class="mr-1">
                      <b-avatar rounded variant="light-primary" size="34">
                        <feather-icon icon="MapPinIcon" size="18" />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body>
                      <h6 v-if="detailsDonation.governorate">
                        {{ detailsDonation.governorate.name_ar }}
                      </h6>
                    </b-media-body>
                  </b-media>
                  <b-media
                    no-body
                    style="display: flex; align-items: center; margin-top: 30px"
                  >
                    <b-media-aside class="mr-1">
                      <b-avatar rounded variant="light-primary" size="34">
                        <img
                          :src="require(`@/assets/global/time_primary.png`)"
                          width="20"
                          height="20"
                        />
                      </b-avatar>
                    </b-media-aside>
                    <b-media-body>
                      <h6>
                        انتهاء الحملة بعد
                        {{ detailsDonation.remaining_time }} يوم
                      </h6>
                    </b-media-body>
                  </b-media>
                </div>
                <div class="col-md-6 m-0">
                  <app-timeline class="m-1 mt-2">
                    <app-timeline-item
                      title="تاريخ بداية الحملة"
                      :subtitle="detailsDonation.start_date"
                      variant="success"
                    />
                    <app-timeline-item
                      title="تاريخ نهاية الحملة"
                      :subtitle="detailsDonation.end_date"
                      variant="info"
                    />
                  </app-timeline>
                </div>
              </div>
              <b-list-group v-if="detailsDonation.donors.length !== 0">
                <h3 class="text-primary mb-2">المتبرعين</h3>
                <div
                  class="d-flex align-items-center mb-1 donors"
                  v-for="item in detailsDonation.donors"
                  :key="item.id"
                >
                  <span class="mr-1">
                    <b-img
                      :src="require('@/assets/global/user_male.png')"
                      width="45"
                      height="45"
                      alt=""
                    />
                  </span>
                  <h6>{{ item.name }}</h6>
                </div>
              </b-list-group>
              <div></div>
            </div>
            <div class="col-lg-6">
              <div class="my-2">
                <h5 class="text-primary" v-if="detailsDonation.ngo">
                  {{ detailsDonation.ngo.name_ar }}
                </h5>
              </div>
              <div class="my-2">
                <ul>
                  <li
                    style="list-style-type: disc"
                    v-if="detailsDonation.name_ar"
                  >
                    <h6>{{ detailsDonation.name_ar }}</h6>
                  </li>
                </ul>
              </div>
              <div>
                <p v-html="detailsDonation.description_ar" class="px-1"></p>
              </div>
              <div>
                <div
                  class="font-weight-bold text-center"
                  style="position: relative; top: 40px"
                  v-if="
                    percentageCalculator(
                      detailsDonation.remaining_amount,
                      detailsDonation.campaign_type
                        ? detailsDonation.campaign_amount
                        : detailsDonation.count
                    ) <= 5
                  "
                >
                  {{
                    "(" +
                    percentageCalculator(
                      detailsDonation.remaining_amount,
                      detailsDonation.campaign_type
                        ? detailsDonation.campaign_amount
                        : detailsDonation.count
                    ) +
                    "%)"
                  }}
                </div>
                <b-progress
                  max="100"
                  class="progress-bar-secondary donationProgress my-2"
                >
                  <b-progress-bar
                    :value="`${percentageCalculator(
                      detailsDonation.remaining_amount,
                      detailsDonation.campaign_type
                        ? detailsDonation.campaign_amount
                        : detailsDonation.count
                    )}`"
                    :label="`${
                      percentageCalculator(
                        detailsDonation.remaining_amount,
                        detailsDonation.campaign_type
                          ? detailsDonation.campaign_amount
                          : detailsDonation.count
                      ) >= 5
                        ? '(' +
                          percentageCalculator(
                            detailsDonation.remaining_amount,
                            detailsDonation.campaign_type
                              ? detailsDonation.campaign_amount
                              : detailsDonation.count
                          ).toFixed(2) +
                          '%)'
                        : ''
                    }`"
                    variant="info"
                  />
                </b-progress>
              </div>
              <div class="d-flex justify-content-around my-2">
                <div class="text-center">
                  <div>
                    {{
                      detailsDonation.campaign_type
                        ? "مبلغ التبرع"
                        : "تم التبرع بـ"
                    }}
                  </div>
                  <span class="nomber_donation font-weight-bold text-success">{{
                    detailsDonation.campaign_type
                      ? (
                          detailsDonation.campaign_amount -
                          detailsDonation.remaining_amount
                        ).toLocaleString("en-US")
                      : detailsDonation.count - detailsDonation.remaining_amount
                  }}</span
                  ><span
                    v-if="detailsDonation.campaign_type"
                    class="text-success"
                    >ل.س</span
                  >
                </div>

                <div class="text-center">
                  <div>
                    {{
                      detailsDonation.campaign_type
                        ? "المبلغ المتبقي"
                        : "العدد المتبقي"
                    }}
                  </div>

                  <span class="font-weight-bold text-danger nomber_donation">
                    {{
                      detailsDonation.campaign_type
                        ? detailsDonation.remaining_amount.toLocaleString(
                            "en-US"
                          )
                        : detailsDonation.remaining_amount
                    }}
                  </span>
                  <span v-if="detailsDonation.campaign_type" class="text-danger"
                    >ل.س</span
                  >
                </div>
              </div>
              <div class="d-flex justify-content-around">
                <div class="text-center">
                  <div>نوع التبرع</div>
                  <div
                    class="font-small-4 font-weight-bold"
                    style="margin-top: 9px"
                  >
                    {{ detailsDonation.campaign_type ? "مادي" : "عيني" }}
                  </div>
                </div>
                <div class="text-center">
                  <div>تستهدف</div>
                  <ul
                    class="font-small-4 font-weight-bold"
                    style="margin-top: 9px"
                    v-if="detailsDonation.ageCategories"
                  >
                    <li
                      v-for="(itemAge, i) in detailsDonation.ageCategories"
                      :key="i"
                      style="list-style: disc"
                    >
                      {{ itemAge.name_ar }}
                    </li>
                  </ul>
                </div>
                <div class="text-center">
                  <div>عدد المتبرعين</div>
                  <span class="font-large-1 font-weight-bold">{{
                    detailsDonation.donors_numbers
                  }}</span>
                </div>
              </div>
            </div>

            <div
              class="col-12 d-flex justify-content-end mt-2"
              v-if="$route.name == 'details_donation'"
            >
              <b-button
                variant="primary"
                :to="{
                  name: 'ngo-donation',
                  params: { id: detailsDonation.ngo.id },
                }"
                class="d-flex align-items-center"
              >
                <feather-icon icon="CornerUpRightIcon" class="mr-1" />
                <div>الأنتقال إلى التبرع</div>
              </b-button>
            </div>
          </div>
          <!-- </basc-card> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BascCard from "../../components/BascCard.vue";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import {
  BCard,
  BImg,
  BCardBody,
  BCardText,
  BCardTitle,
  BMedia,
  BMediaAside,
  BAvatar,
  BAvatarGroup,
  VBTooltip,
  BMediaBody,
  BButton,
  BModal,
  VBModal,
  BProgress,
  BProgressBar,
  BSkeleton,
  BListGroup,
  BListGroupItem,
} from "bootstrap-vue";
import { mapGetters } from "vuex";
export default {
  components: {
    BascCard,
    AppTimeline,
    AppTimelineItem,
    BCard,
    BImg,
    BCardBody,
    BCardText,
    BCardTitle,
    BMedia,
    BMediaAside,
    BAvatar,
    BAvatarGroup,
    VBTooltip,
    BMediaBody,
    BButton,
    BModal,
    VBModal,
    BProgress,
    BProgressBar,
    BSkeleton,
    BListGroup,
    BListGroupItem,
  },
  computed: {
    ...mapGetters("NgoHome/donation", [
      "loadingDetailsDonation",
      "detailsDonation",
    ]),
  },
  methods: {
    percentageCalculator(remaining_amount, campaign_amount) {
      return parseInt(
        ((campaign_amount - remaining_amount) / campaign_amount) * 100
      );
    },
  },
  created() {
    this.$store.dispatch(`NgoHome/donation/getDetailsDonation`, {
      id: this.$route.params.id,
    });
  },
};
</script>
<style lang="scss">
.donors {
  border-left: 4px solid #048042;
  padding: 5px;
  margin-bottom: 3px;
  span {
    img {
      border: 1px solid #00000028;
      border-radius: 50%;
    }
  }
}
.donationProgress {
  height: 15px;
  .progress-bar {
    cursor: pointer;
    position: static;
    height: 15px;
    background-color: #048042 !important;
    &:hover {
      background-color: #0e5696c4 !important;
    }
  }
}

.nomber_donation {
  font-size: 25px;
}
.img_donation {
  width: 100%;
  height: auto;
}
@media (max-width: 500px) {
  .img_donation {
    width: 100%;
    height: 210px;
  }
  .nomber_donation {
    font-size: 18px;
  }
}
</style>
